import React from 'react';
import { getTypeFromModule } from '../Util/Module';

const getLegendItemsFromModules = function (modules) {
  const types = modules.reduce(function (acc, module) {
    const [typeName, type] = getTypeFromModule(module);
    acc[typeName] = type;

    return acc;
  }, {});

  return Object.entries(types);
};

export class Legend extends React.Component {
  render() {
    const types = getLegendItemsFromModules(this.props.modules);

    const itemsElements = types.map(([key, item]) => {
      return (
        <li key={key}>
          <div
            className="legend__icon"
            style={{ backgroundColor: item.color }}
          />
          <div className="legend__label">{item.label}</div>
        </li>
      );
    });
    return <ul className="legend">{itemsElements}</ul>;
  }
}
